import { createReducer, on } from '@ngrx/store';
import { StorageService } from '../../services/storage.service';
import { rollupActions } from './rollups.actions';
import {
  IRollupFilters,
  IRollupGCLineItem,
  IRollupLineItems,
  IRollupLineItemTable,
  IRollupPrimeProject,
  IRollupProject,
  IRollupSubProject,
  IRollupTag,
  IRollupTagTable,
  ROLLUP_VIEW_TYPES,
} from './rollups.interface';

export const rollupFeatureKey = 'rollups';

export interface RollupState {
  isLoading: boolean;
  isFetching: boolean;
  projects_list: IRollupProject[];
  line_items_list: IRollupLineItems[] | IRollupGCLineItem[];
  tags_list: IRollupTag[];
  prime_projects_list: IRollupPrimeProject[];
  sub_projects_list: IRollupSubProject[];
  selectedRollupData: IRollupLineItemTable | IRollupTagTable | IRollupGCLineItem;
  selectedRollupViewType: ROLLUP_VIEW_TYPES;
  filters: IRollupFilters;
  showZeroDollarLines: boolean;
}

export const initialState: RollupState = {
  isLoading: true, // general loading for loading screen
  isFetching: true,
  projects_list: [],
  line_items_list: [],
  tags_list: [],
  prime_projects_list: [],
  sub_projects_list: [],
  selectedRollupViewType: null,
  selectedRollupData: null,
  filters: StorageService.getRollupFilters(),
  showZeroDollarLines: false,
};

export const rollupsReducer = createReducer(
  initialState,
  on(rollupActions.rollupByViewSuccessfullyLoaded, (state, action): RollupState => {
    const newState = { ...state, isLoading: false, isFetching: false };
    switch (action.view) {
      case ROLLUP_VIEW_TYPES.PROJECTS:
        return { ...newState, projects_list: action.data as IRollupProject[] };
      case ROLLUP_VIEW_TYPES.BUDGET_LINE_ITEMS:
        return { ...newState, line_items_list: action.data as IRollupLineItems[] };
      case ROLLUP_VIEW_TYPES.TAGS:
        return { ...newState, tags_list: action.data as IRollupTag[] };
      case ROLLUP_VIEW_TYPES.PRIME_PROJECT:
        return { ...newState, prime_projects_list: action.data as IRollupPrimeProject[] };
      case ROLLUP_VIEW_TYPES.SP_PROJECTS:
      case ROLLUP_VIEW_TYPES.SUB_PROJECT:
        return { ...newState, sub_projects_list: action.data as IRollupSubProject[] };
      default:
        console.warn('rollupByViewSuccessfullyLoaded: unhandled view type');
        return newState;
    }
  }),
  on(rollupActions.isLoading, (state, action): RollupState => {
    return { ...state, isFetching: action.isLoading };
  }),
  on(rollupActions.rollupByViewLoadCancelled, (state): RollupState => {
    return { ...state, isFetching: false, isLoading: false };
  }),
  on(rollupActions.setSelectedRollup, (state, action): RollupState => {
    return { ...state, selectedRollupViewType: action.viewType, selectedRollupData: action.data };
  }),
  on(rollupActions.clearRollups, (): RollupState => {
    StorageService.setDefaultRollupFilters();
    return { ...initialState, filters: StorageService.getRollupFilters() };
  }),
  on(rollupActions.setRollupFilters, (state, action): RollupState => {
    return { ...state, filters: { ...state.filters, ...action.filters } };
  }),
  on(rollupActions.toggleShowZeroDollarLines, (state, action): RollupState => {
    return { ...state, showZeroDollarLines: action.showZeroDollarLines };
  }),
);
